export const BLOCK_INFO_API = "/api/block_info";
export const BLOCK_INFOS_API = "/api/block_infos";
export const BLOCK_CANDLES_API = "/api/block_candles";
export const WS_API = "wss://ws-proxy-282321022710.europe-west1.run.app";

export const BLOCK_GAS_MOD = 5
export const BLOCK_PARAM = "block";
export const GAS_LIMIT = 60000000;
export const MERGE_BLOCK = 15537394;
export const VIEW_LIVE = "live";
export const VIEW_HISTORICAL = "historical";
export const SLOT_TIME = 12;
export const TEMP_CANDLES = 168;
export const BUILDER_UNKNOWN = "<unknown>";
export const BUILDER_VANILLA = "vanilla";


export function isNumber(str) {
    return /^\d+$/.test(str);
}

export function relayURL(relayKey) {
    switch (relayKey.toLowerCase()) {
        case "agnostic":
            return "https://agnostic-relay.net";
        case "bloxroute-ethical":
            return "https://bloxroute.ethical.blxrbdn.com";
        case "bloxroute-max-profit":
            return "https://bloxroute.max-profit.blxrbdn.com";
        case "bloxroute-regulated":
            return "https://bloxroute.regulated.blxrbdn.com";
        case "eden":
            return "https://relay.edennetwork.io";
        case "flashbots":
            return "https://boost-relay.flashbots.net";
        case "blocknative":
            return "https://builder-relay-mainnet.blocknative.com";
        case "aestus":
            return "https://mainnet.aestus.live";
        case "ultrasound":
            return "https://relay.ultrasound.money";
        case "securerpc":
            return "https://mainnet-relay.securerpc.com";
        default:
            return "https://payload.de/data";
    }
}

export function relayName(relayKey) {
    switch (relayKey.toLowerCase()) {
        case "agnostic":
            return "Agnostic";
        case "bloxroute-ethical":
            return "BloXroute Ethical";
        case "bloxroute-max-profit":
            return "BloXroute Max Profit";
        case "bloxroute-regulated":
            return "BloXroute Regulated";
        case "eden":
            return "Eden";
        case "flashbots":
            return "Flashbots";
        case "blocknative":
            return "Blocknative";
        case "aestus":
            return "Aestus";
        case "ultrasound":
            return "Ultrasound";
        case "securerpc":
            return "Manifold";
        default:
            return "Unknown";
    }
}

export function formatRelayMap(relays) {
    var relayList = [];
    if (relays != undefined) {
        for (const [key, value] of Object.entries(relays)) {
            relayList.push({ url: relayURL(key), name: relayName(key) });
        }
        if (relayList.length > 0) {
            relayList.sort((a, b) => a.name.localeCompare(b.name));
            const relayAnchors = relayList
                .map((relay) => `<a href="${relay.url}" target="_blank" title="${relay.url}">${relay.name}</a>`)
                .join(", ");
            return relayAnchors;
        }
    }
    return "-";
}

export function formatBuilder(block_info) {
    var label = block_info.builder;
    var builder_pubkey = "";
    if (block_info.winner.builder_pubkey != "") {
        builder_pubkey = `<span id="builder_pubkey" title="${block_info.winner.builder_pubkey}" style="color:#d3d3d3;cursor:pointer"> &#128477;</span>`;
    }
    if (block_info.coinbase == block_info.fee_recipient) {
        var extra = "";
        if ((label.toLowerCase() == BUILDER_UNKNOWN || label.toLowerCase() == "" || label.toLowerCase() == BUILDER_VANILLA) && block_info.extra != "") {
            extra = `(${block_info.extra})`;
        }
        return label
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;") + " " + extra + builder_pubkey;
    } else {
        if (label.toLowerCase() == BUILDER_UNKNOWN || label.toLowerCase() == "") {
            var coinbase = block_info.coinbase;
            var firstFive = coinbase.slice(0, 5);
            var lastFive = coinbase.slice(-5);
            var addr = firstFive + "..." + lastFive;

            var extra = "";
            if (block_info.extra != "") {
                extra = `(${block_info.extra})`;
            }
            const link = `https://etherscan.io/address/${block_info.coinbase.toLowerCase()}`;
            return `<a href="${link}" target="_blank" title="${block_info.coinbase}">${addr}</a> ${extra}${builder_pubkey}`;
        } else {
            const link = `https://etherscan.io/address/${block_info.coinbase.toLowerCase()}`;
            return `<a href="${link}" target="_blank" title="${block_info.coinbase}">${label}</a>${builder_pubkey}`;
        }
    }
}

export function formatValidator(block_info) {
    var address = block_info.fee_recipient;
    var label = address;
    var proposer_pubkey = "";
    if (block_info.winner.proposer_pubkey != "") {
        proposer_pubkey = `<span id="proposer_pubkey" title="${block_info.winner.proposer_pubkey}" style="color:#d3d3d3;cursor:pointer"> &#128477;</span>`;
    }
    if (block_info.validator == undefined || block_info.validator == "") {
        if (label.length >= 10) {
            var firstFive = address.slice(0, 5);
            var lastFive = address.slice(-5);
            label = firstFive + "..." + lastFive;
        }
    } else {
        label = block_info.validator;
    }
    const link = `https://etherscan.io/address/${address.toLowerCase()}`;

    return `<a href="${link}" target="_blank" title="${address}">${label}</a>${proposer_pubkey}`;
}

export function getFormattedDate(timestampSeconds) {
    var timestampMilliseconds = timestampSeconds * 1000;
    var date = new Date(timestampMilliseconds);

    var day = date.getUTCDate();
    var month = date.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
    var year = date.getUTCFullYear();
    var hours = String(date.getUTCHours()).padStart(2, '0');
    var minutes = String(date.getUTCMinutes()).padStart(2, '0');
    var seconds = String(date.getUTCSeconds()).padStart(2, '0');

    var formattedDate = month + ' ' + day + ', ' + year + ' ' + hours + ':' + minutes + ':' + seconds + ' UTC';

    return formattedDate;
}

export function generateEmptyInfo() {
    return {
        slot: 0,
        block: 0,
        block_hash: "",
        builder: "",
        coinbase: "",
        validator: "",
        fee_recipient: "",
        payment: "",
        difference: 0,
        payout: 0,
        payback: 0,
        alimony: 0,
        gas_used: 0,
        base_fee: 0,
        prio_fee: 0,
        extra: "",
        relays: "",
        best: {},
        winner: {},
        submissions: [],
        transactions: [],
        timestamp: ""
    };
}